import React, { useEffect } from 'react';

import { StepProps, track, useAutoNavigate } from '@betterment/js-runtime';
import { Box, SuccessFullScreen } from '@betterment/samba-react';

import { CustomerSignupValues } from './Controller';

import { useCustomerResponse } from '../Checking/components/CustomerResponseProvider';
import SignupPending from '../Checking/components/SignupPending';
import { isSignedUp } from '../Checking/models/customer';
import { gtmTrack } from '../Shared/google-tag-manager-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

type Props = StepProps<CustomerSignupValues>;

const Success: React.FC<React.PropsWithChildren<Props>> = ({ flowState, goToNextStep }) => {
  const { customer, loading: isCustomerLoading, refetch: reloadCustomer } = useCustomerResponse();
  const isWaiting = isCustomerLoading || (customer && !isSignedUp(customer)) || !customer;
  const navigate = useAutoNavigate();
  const { accountType, invitationId } = flowState.values;
  const isSecondaryUser = invitationId !== undefined;
  const onCompletionHandler = () => {
    if (accountType === 'joint') {
      void navigate(urlBuilder.getAppCheckingJointAccounts.absolute({ accountId: customer!.accounts[0].id }));
    } else {
      goToNextStep({ customer, accountId: customer!.accounts[0].id });
    }
  };

  useEffect(() => {
    gtmTrack('checkingAccountCreated');
    track('ElementViewed', { name: 'BettermentAccountApproved', flow: 'OpenCheckingAccount' });
  }, []);

  const signupPendingMessage = isSecondaryUser
    ? 'Creating your Joint Checking account...'
    : 'Creating your Checking account...';

  const successMessage = isSecondaryUser ? 'Joint Checking account created' : 'Checking account created';

  return isWaiting ? (
    <Box>
      <SignupPending message={signupPendingMessage} reloadCustomer={reloadCustomer} />
    </Box>
  ) : (
    <SuccessFullScreen message={successMessage} onCompletion={onCompletionHandler} />
  );
};

export default Success;
